<script>
import Fourier from './Fourier.svelte';

</script>

<!-- <div style="z-index: 432;" class="vig"></div> -->

<!-- <div class="tree"></div> -->
<div class='vig'>
	<!-- <img src="/forest.jpg" /> -->
	<video autoplay loop muted>
		<!-- <source src="/scene.webm" /> -->
		<source src="/forest.mp4" />
	</video>
	<audio style="z-index:32;position: absolute;top: 100vh; left: 0" autoplay src="/birds-5min.mp3" controls />
</div>

<div class="block row vcenter">
	<!-- <Fourier styleWidth={42} /> -->
	<div class="col f1" style="margin-left: 24px">
		<!-- <div style="text-transform: uppercase;font-size: 12px;opacity: .7; ">Elegant Machines</div> -->
		<div class="text2">
			STANDARDDIGITAL
		</div>
		<div style="text-transform: uppercase;font-size: 12px;opacity: .7;margin-top: -6px">Software Design and Production Group</div>
		<div class="hr2"></div>
		<div class="row">
			<div>Portfolio</div>
			<div style="margin-left: 24px">Contact</div>
		</div>
	</div>
</div>

<div class="page2 row vcenter hcenter">
	<div class="col end">
		<div class="text">
			ELEGANT MACHINES
		</div>
	</div>
	<Fourier />
</div>

<div class="block2 col hcenter">
	<div class="hr" />
	<div>Standard Digital</div>
	<div>a Software Design and Production Group</div>
</div>

<!-- <div class="center row vcenter">
	<div class="col end">
		<div class="text">
			ELEGANT MACHINES
		</div>
	</div>
	<Fourier />
</div>
 -->

<!-- <div>M = ⟨Q, Γ, b, Σ, δ, q<sub>0</sub>, F⟩</div> -->

<style>
/* :global(body) {
	background-image: url(https://picsum.photos/480/200?random);
	background-size: cover;
} */

.center {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);

	animation: fadein 2s;
}

.block {
	position: absolute;
	left: 200px;
	right: 200px;
	top: 70%;

	animation: fadein 2s;
}

.text2 {
	font-size: 32px;
	font-weight: bold;
	color: white;
	animation: fadein 4s;
	font-family: 'Helvetica Neue';
	text-shadow: 0 0 11px #1e2e1d, 0 0 11px #1e2e1d;
}

.page2 {
	position: absolute;
	top: 100vh;
	left: 0;
	height: 100vh;
	width: 100vw;
}

.text {
	font-size: 32px;
	font-weight: bold;
	color: #D4E8FF;
	-webkit-text-fill-color: transparent;
	-webkit-background-clip: text;
	/* background-image: inherit; */
	background-image: url(https://picsum.photos/480/200?random);
	/* background: linear-gradient(to right, #D4E8FF, rgba(40, 40, 40, 1) 50%); */
	margin-right: 24px;

	animation: fadein 2s;
}

/* perspective(120px) rotateY(-4deg) translatez(0) translatex(-80px) */

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

.hr {
	height: 1px;
	width: 300px;
	background-color: rgb(84 84 84);;
	margin-bottom: 17px;
}

.hr2 {
	height: 1px;
	width: 100%;
	background-color: white;
	margin-bottom: 17px;
	animation: slideout 2s ease-out;
}

@keyframes slideout {
	from { width: 0%; }
	to   { width: 100%; }
}

.block2 {
	position: absolute;
	top: 185%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: rgb(189 189 189);
	/* color: rgb(173 204 243); */
	/* color: rgb(179 155 155); */
	/* color: rgb(212, 232, 255); */
	font-weight: 200;
	font-size: 14px;
	animation: fadein 5s;
}

.tree {
	/* background-image: url(/magic.png); */
	/* background-image: url(/project/2gthr.png); */
	background-size: cover;
	width: 100vw;
	height: 100vh;
	box-shadow: inset 0 0 200px 100px black;
}

video { 
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.vig {
	position: absolute;
	top: 0; left: 0; width: 100vw; height: 100vh;
	box-shadow: inset 0 0 200px 100px black;
}
</style>